<template>
    <div class="animated fadeIn detail-pusat-page">
            <button type="button" class="btn btn-back mb-3" @click="$router.go(-1)" name="backBtn">
                <i class="fa fa-angle-left mr-1"></i> Back
            </button>
            <div class="detail-pusat-card">
                <h4 class="page-title mb-4">Detail Penarikan</h4>
        <DetailGadaiKomp :detailGadai="dataPenarikan" />
        <div class="detail-data-wrapper">
            <h6 class="form-title">DATA FOTO PENARIKAN</h6>
            <b-row class="mb-2">
                <b-col cols="4" class="detail-data-label">Foto Penarikan</b-col>
                <b-col>
                    <a v-bind:href="$baseFilePath+dataFotoPenarikan" target="_blank">
                        <img width="150px" :src="$baseFilePath+dataFotoPenarikan" alt="Foto Penarikan">
                    </a>
                    <span class="file-name mt-2"></span>
                </b-col>
            </b-row>
        </div>

            </div>
    </div>
</template>

<script>
import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-penarikan',
    components: {
        DetailGadaiKomp,
    },
    props: {
        dataPenarikan: { type: Object, required: true },
        dataFotoPenarikan: { type: String, required: true }
    },
    // data(){
    //     return{
    //         id: null,
    //         initStatus: 0,
    //         isSubmitting: false,
    //         dataDetailPenarikan: [],
    //         dataFotoPenarikan: ""
    //     }
    // }, 
    // methods:{

    //     //----------------- Fungsi Inisialisasi -----------------

    //     init(){
    //         this.initStatus = 0
    //         this.id = this.$route.params.id

    //         let getSingleGadai = this.$axios.get(`gadai/detail/id/${this.id}`).then(response => {
    //             this.dataDetailPenarikan = response.data
    //             console.log(response.data)
    //         })

    //         let getFotoPenarikan = this.$axios.get(`daftar-penarikan/foto?gadaiId=${this.id}`).then(response => {
    //             this.dataFotoPenarikan = response.data
    //         })

    //         Promise.all([getSingleGadai, getFotoPenarikan]).then(() => {
    //             this.initStatus = 1
    //         })
    //         .catch(error => {
    //             console.log(error)
    //             this.initStatus = -1
    //         })
    //     },
        
    // },

    // created(){
    //     this.init()
    // }
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.detail-pusat-page {
    padding-bottom: 30px;
}

.detail-pusat-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    padding: 24px 28px 28px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Judul seksi: batang aksen brass + garis bawah
::v-deep .detail-data-wrapper h6.form-title,
::v-deep .form-content-wrapper h6.form-title {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding-left: 12px;
    padding-bottom: 8px;
    margin-bottom: 14px;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 1px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

::v-deep .detail-data-wrapper {
    margin-bottom: 28px;
}

// Baris label / nilai
::v-deep .row.mb-2 {
    padding-bottom: 8px;
    margin-left: 0;
    margin-right: 0;
    font-size: 13px;
    color: $ink-body;
}

::v-deep .detail-data-label {
    font-weight: 500;
    font-size: 13px;
    color: #6E827C;
    overflow-wrap: break-word;

    strong { font-weight: 600; }
}

// Form
::v-deep .form-group label {
    font-size: 13px;
    font-weight: 600;
    color: $ink-body;
    margin-bottom: 8px;
}

::v-deep .field-input,
::v-deep .field-select,
::v-deep textarea.form-control,
::v-deep input.form-control,
::v-deep select.form-control {
    border-radius: 8px;
    border: 1px solid $input-border;
    font-size: 13px;
    color: $ink-body;
    padding: 8px 14px;

    &:focus {
        border-color: $deep-pine;
        box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
        outline: none;
    }
}

::v-deep textarea.form-control { min-height: 96px; }

// Gambar bukti
::v-deep .detail-data-wrapper img {
    border-radius: 8px;
    border: 1px solid $line-border;
}

// Tabel di dalam detail
::v-deep .table thead th {
    background-color: #F5FAF7;
    border-top: none;
    border-bottom: 1px solid $line-border;
    font-size: 11px;
    font-weight: 700;
    color: #4A5D56;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    padding: 12px 16px;
}

::v-deep .table tbody td {
    padding: 12px 16px;
    border-top: 1px solid #EDF2EF;
    font-size: 13px;
    color: $ink-body;
    vertical-align: middle;
}

// Tombol aksi
.detail-actions-footer {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 24px;
}

.btn-submit {
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    padding: 10px 24px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.2s ease;

    &:hover {
        background-color: $deep-pine-hover;
        border-color: $deep-pine-hover;
        color: #FFFFFF;
    }
}

.btn-cancel {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 13.5px;
    font-weight: 500;
    transition: all 0.2s ease;

    &:hover {
        background-color: #F4F7F5;
        border-color: #BAC9C2;
        color: $ink-heading;
    }
}

.btn-danger-outline {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: #9B4A3C;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 13.5px;
    font-weight: 600;
    transition: all 0.2s ease;

    &:hover {
        background-color: #F9EDEB;
        border-color: #E4C4BD;
        color: #9B4A3C;
    }
}
</style>
